export default {"src":"/nachrichten/_next/static/media/ThemeSystemIcon.c4ec9c2d.svg","height":124,"width":70,"blurWidth":0,"blurHeight":0};